/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LexplusAnforderungStatusEnum } from '../../models/lexplus-anforderung-status-enum';
import { LexplusComplianceSortDirectionEnum } from '../../models/lexplus-compliance-sort-direction-enum';
import { LexplusStandortvergleichListResponseDto } from '../../models/lexplus-standortvergleich-list-response-dto';
import { LexplusStandortvergleichSortColumnEnum } from '../../models/lexplus-standortvergleich-sort-column-enum';

export interface AuswertungenControllerGetStandortvergleichV1$Params {

/**
 * Matches the Artikel number, the description and the Erlass name.
 */
  search?: string;
  standortIDs?: Array<number>;

/**
 * Only Neu, NeueVersion and Bestehend can match outside the Archiv scope, which holds Ersetzt and Entfernt. Unveraendert, AlteVersion and ZuPruefen belong to a Neosys-internal comparison and are never stored, so they match nothing.
 */
  status?: Array<LexplusAnforderungStatusEnum>;
  rechtsbereichIDs?: Array<number>;
  sortDirection?: LexplusComplianceSortDirectionEnum;
  page?: number;
  limit?: number;

/**
 * The column to order by; the Erlass when absent. `sortDirection` gives the direction, ascending when absent.
 */
  sortColumn?: LexplusStandortvergleichSortColumnEnum;
}

export function auswertungenControllerGetStandortvergleichV1(http: HttpClient, rootUrl: string, params?: AuswertungenControllerGetStandortvergleichV1$Params, context?: HttpContext): Observable<StrictHttpResponse<LexplusStandortvergleichListResponseDto>> {
  const rb = new RequestBuilder(rootUrl, auswertungenControllerGetStandortvergleichV1.PATH, 'get');
  if (params) {
    rb.query('search', params.search, {});
    rb.query('standortIDs', params.standortIDs, {});
    rb.query('status', params.status, {});
    rb.query('rechtsbereichIDs', params.rechtsbereichIDs, {});
    rb.query('sortDirection', params.sortDirection, {});
    rb.query('page', params.page, {});
    rb.query('limit', params.limit, {});
    rb.query('sortColumn', params.sortColumn, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LexplusStandortvergleichListResponseDto>;
    })
  );
}

auswertungenControllerGetStandortvergleichV1.PATH = '/v1/auswertungen/standortvergleich';
